import { render, staticRenderFns } from "./DuplicateItem.vue?vue&type=template&id=942664ca"
import script from "./DuplicateItem.vue?vue&type=script&lang=js"
export * from "./DuplicateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports